import {useContext} from "react";

import {
    PageDisplayContext,
    type PageDisplayContextType,
} from "./page-display-container.tsx";

/**
 * A hook that is a simple wrapper around PageDisplayContext. You can use this
 * hook to access the current page settings, or to modify them using the update
 * function.
 *
 * Usage:
 *  const {settings, update} = usePageSettings();
 *  update({title: "My Title"});
 */
export function usePageSettings(): PageDisplayContextType {
    return useContext(PageDisplayContext);
}
